import { configureStore, Tuple } from '@reduxjs/toolkit'

import adobeTriggerView from '~/middleware/adobe-trigger-view'
import keepAlive from '~/middleware/keep-alive'
import reducer from '~/reducers'
import { enhancedCommerceMiddleware } from '~/utils/enhanced-commerce-tracking'

const customMiddleware = [
  enhancedCommerceMiddleware,
  keepAlive,
  adobeTriggerView(),
]

export function createAndInitializeStore() {
  const initialState = {
    profile: { loaded: false },
  }

  return configureStore({
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(new Tuple(...customMiddleware)),
    reducer,
    preloadedState: initialState,
  })
}

const store = createAndInitializeStore()

export type RootState = ReturnType<typeof store.getState>
export type Dispatch = typeof store.dispatch

export default store
